// Gedeelde environment-config — de single source of truth.
// environment.ts (dev), environment.prod.ts en environment.test.ts spreaden dit
// en overschrijven enkel hun eigen verschillen. Voeg nieuwe keys HIER toe.
export const baseEnvironment = {
  appVersion: require("../../../../package.json").version,
  production: false,
  apiUrl: "https://test.assistonline.eu/api/",
  publicApiUrl: "https://publicapi.assistonline.eu/",
  authenticationServer: "https://account.assistonline.eu/",
  mijnUrl: "https://nieuw.mijnassist.be/",
  vrijwilligerswerkUrl: "https://beheer.vrijwilligerswerk.be",
  assistUrl: "https://nieuw.assistonline.eu",
  imageUrl: "https://app.assistonline.eu",
  loginUrl: "https://app.assistonline.eu/externalLogin/Login.aspx",
  appKey: "D7E5D684-B5E5-492B-A4FE-337A4E3C6C5E",
  unsplashAccessKey: "wjcozG9L8tyVN7LbfaeVpqAO0ZvfWwaY1t682QBTFLk",
  pexelsApiKey: "9VD1utzwLpKj43W0Ka7gWByTxD8xddvz66mvwS6JHi1pC2MfaYBbjVJo",
  googleAnalyticsId: "",
  beaconId: "75008245-5a38-4cf6-9bbe-9e7df61aadd5",
  beaconEnabled: true,
};

export type Environment = typeof baseEnvironment;
